import { DoodleBadge } from "@/shared/doodles/DoodleBadge";

/**
 * The start of the till's phone head line (waiter phone, 2026-10-28): the
 * table's badge, its name, and one quiet line under it — «فاتورة #1 · كريم»
 * on a bill, «جديدة» on a table with none yet. The bell and sign-out close
 * the same line (`TillPhoneControls`).
 */
export function TillPhoneLead({
  name,
  meta,
}: {
  name: string;
  meta: string | null;
}) {
  return (
    <div data-ui="till-phone-lead" data-testid="till-phone-lead">
      <DoodleBadge id="cutlery" size={32} animate={false} />
      <div className="flex min-w-0 flex-col">
        <bdi data-ui="till-phone-lead-name">{name}</bdi>
        {meta ? <span data-ui="till-phone-lead-meta">{meta}</span> : null}
      </div>
    </div>
  );
}
